import React, { useState } from 'react'
import { cn } from '../../utils/ui'

/**
 * InteractiveGridPattern is a component that renders a grid pattern with interactive squares.
 *
 * @param width - The width of each square.
 * @param height - The height of each square.
 * @param squares - The number of squares in the grid. The first element is the number of horizontal squares, and the second element is the number of vertical squares.
 * @param className - The class name of the grid.
 * @param squaresClassName - The class name of the squares.
 */
export default function InteractiveGridPattern({
  width = 40,
  height = 40,
  squares = [24, 24],
  className,
  squaresClassName,
  ...props
}) {
  const [_horizontal, _vertical] = squares
  const [_hoveredSquare, setHoveredSquare] = useState(null)

  return (
    <svg
      width={width * _horizontal}
      height={height * _vertical}
      className={cn('absolute inset-0 h-full w-full border border-gray-400/30', className)}
      {...props}
    >
      {Array.from({ length: _horizontal * _vertical }).map((_, index) => {
        const x = (index % _horizontal) * width
        const y = Math.floor(index / _horizontal) * height
        return (
          <rect
            key={index}
            x={x}
            y={y}
            width={width}
            height={height}
            className={cn(
              'stroke-gray-400/30 transition-all duration-100 ease-in-out [&:not(:hover)]:duration-1000 hover:stroke-[#E06100] fill-transparent',
              squaresClassName,
            )}
            onMouseEnter={() => setHoveredSquare(index)}
            onMouseLeave={() => setHoveredSquare(null)}
          />
        )
      })}
    </svg>
  )
}